import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { useShowPricePerMonthPerSeat } from '../seats-display/useSeatsDisplay';
import { PriceDisplayStyled } from './PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceDisplayContainer = ({
  skuId,
  queryParamTerm,
  nonMerchandiseIdProduct,
  apiName
}) => {
  const {
    purchaseOptionsForTerm,
    loading
  } = usePurchaseableProductsForTerm({
    queryParamTerm,
    apiName
  });
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId
  });
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  if (!purchaseOptionsForTerm && !loading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20],
    widths: [60],
    children: purchaseOptionsForTerm && /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: purchaseOptionsForTerm,
      showPricePerMonthPerSeat: showPricePerMonthPerSeat,
      seleniumId: apiName || nonMerchandiseIdProduct || 'loading',
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};